<template>
  <div class="classListBox">
    <div class="serItem">
      <div class="titleNav">
        {{ $t('class.classType') }}
      </div>
      <a-menu
        style="width: 160px"
        :default-selected-keys="[1]"
        mode="inline"
        @click="handleClick"
      >
        <a-menu-item v-for="item in classTypeData" :key="item.id">
          <span> {{ $t(`${item.name}`) }}</span>
        </a-menu-item>
        <!-- <a-menu-item key="2">
          <span>{{ $t('class.electiveClass') }}</span>
        </a-menu-item> -->
      </a-menu>
    </div>
    <div class="serItem">
      <div class="page-content class-list">
        <div class="search-wrap">
          <div class="search-options-wrap">
            <div class="option-item">
              <div class="option-title">{{ $t('public.status') }}</div>
              <a-select
                allowClear
                showSearch
                v-model="status"
                style="width: 100%"
                :placeholder="$t('public.status')"
                :filterOption="filterOption"
                :dropdownMatchSelectWidth="false"
                @change="handleSearch"
              >
                <a-select-option
                  v-for="(item, index) in classStatusList"
                  :key="index"
                  :value="item.value"
                >
                  {{ $t(item.label) }}
                </a-select-option>
              </a-select>
            </div>

            <div class="option-item">
              <div class="option-title">{{ $t('public.grade') }}</div>
              <a-select
                allowClear
                showSearch
                v-model="grade"
                style="width: 100%"
                :placeholder="$t('public.grade')"
                :filterOption="filterOption"
                :dropdownMatchSelectWidth="false"
                @change="handleSearch"
              >
                <a-select-option
                  v-for="(item, index) in gradeOptions"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </div>

            <div class="option-item">
              <div class="option-title">{{ $t('public.startedYear') }}</div>
              <a-select
                allowClear
                v-model="year"
                style="width: 100%"
                :placeholder="$t('public.startedYear')"
                :dropdownMatchSelectWidth="false"
                @change="handleSearch"
              >
                <a-select-option
                  v-for="(item, index) in yearOptions"
                  :key="index"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </div>
            <div class="option-item">
              <div class="option-title">{{ $t('public.ClassAdviser') }}</div>
              <a-select
                allowClear
                v-model="classAdviserId"
                style="width: 100%"
                :placeholder="$t('public.ClassAdviser')"
                :dropdownMatchSelectWidth="false"
                @change="handleSearch"
              >
                <a-select-option
                  v-for="item in ListClassAdviser"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
            <div class="search-wrap--input">
              <a-input-search
                :placeholder="
                  $t('public.searchList', { content: $t('public.class_lower') })
                "
                style="width: 250px"
                enterButton
                class="search-input"
                v-model="searchModel"
                @search="handleSearch"
              />
            </div>
            <div style="width:200px;height:auto" class="option-item marginCss">
              <a-button
                type="danger"
                @click="btnArchived"
                v-if="handleRightsList.includes('归档')"
              >
                {{ $t('class.archive') }}
              </a-button>
              <a-button
                style="margin-left:5px"
                type="primary"
                @click="btnPromote"
                v-if="handleRightsList.includes('晋升')"
              >
                {{ $t('class.promotion') }}
              </a-button>
            </div>
          </div>
        </div>

        <!-- 表格 -->
        <a-table
          size="middle"
          :rowKey="record => record.id"
          :scroll="{ x: 1000 }"
          :loading="tableLoading"
          :dataSource="dataSource"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: selectChange
          }"
          :pagination="{
            total: total,
            pageSize: pageSize,
            current: current,
            showSizeChanger: true,
            pageSizeOptions: ['25', '50', '100'],
            showTotal: total =>
              $t('public.page', { total: total, pageSize: pageSize }),
            onChange: currentChange,
            onShowSizeChange: showSizeChange
          }"
        >
          <a-table-column :title="$t('public.class')" dataIndex="name">
            <template slot-scope="name">
              <p>{{ name }}</p>
            </template>
          </a-table-column>

          <a-table-column :title="$t('public.grade')" dataIndex="grade">
            <template slot-scope="grade">
              {{ grade | filteGrade('name') }}
            </template>
          </a-table-column>

          <a-table-column
            :title="$t('public.headmaster')"
            dataIndex="teacherName"
          ></a-table-column>

          <a-table-column
            :title="$t('public.student')"
            dataIndex="number"
          ></a-table-column>

          <a-table-column
            :title="$t('public.startedYear')"
            dataIndex="openDate"
          ></a-table-column>

          <a-table-column
            :title="$t('public.operate')"
            align="right"
            dataIndex="handles"
            v-if="
              handleRightsList.includes('花名册') ||
                handleRightsList.includes('编辑') ||
                handleRightsList.includes('删除')
            "
          >
            <template slot-scope="handles, record">
              <a
                v-if="handleRightsList.includes('花名册')"
                href="javascript:;"
                @click="rosterItem(record)"
              >
                {{ $t('public.roster') }}
              </a>
              <a-divider
                v-if="
                  handleRightsList.includes('花名册') &&
                    handleRightsList.includes('编辑')
                "
                type="vertical"
              />
              <a
                href="javascript:;"
                @click="editItem(record)"
                v-if="handleRightsList.includes('编辑')"
              >
                {{ $t('handle.edit') }}
              </a>
            </template>
          </a-table-column>
        </a-table>

        <!-- 添加编辑规则 -->
        <a-drawer
          :title="$t('public.edit', { content: $t('public.class_lower') })"
          :visible="drawerVisible"
          :width="500"
          wrapClassName="drawer-form-wrap"
          @close="handleClose"
        >
          <div class="form-wrap">
            <a-form :form="form">
              <a-form-item
                :label="$t('public.title')"
                :extra="
                  `${
                    form.getFieldValue('name')
                      ? form.getFieldValue('name').length
                      : '0'
                  }/64`
                "
                :labelCol="formItemLayout.labelCol"
                :wrapperCol="formItemLayout.wrapperCol"
              >
                <a-input
                  :maxLength="64"
                  :placeholder="$t('public.title')"
                  v-decorator="[
                    'name',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('public.pleaseFill', {
                            content: $t('public.title')
                          })
                        }
                      ]
                    }
                  ]"
                >
                </a-input>
              </a-form-item>

              <!-- <a-form-item
            :label="$t('public.studentNumber')"
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-input-number
              :min="0"
              v-decorator="[
                'number',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('public.pleaseFill', {
                        content: $t('public.studentNumber')
                      })
                    }
                  ]
                }
              ]"
            />
          </a-form-item> -->

              <a-form-item
                :label="$t('public.grade')"
                :labelCol="formItemLayout.labelCol"
                :wrapperCol="formItemLayout.wrapperCol"
              >
                <a-select
                  :placeholder="$t('public.grade')"
                  style="width: 200px"
                  v-decorator="[
                    'grade',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('public.pleaseChoose', {
                            content: $t('public.grade')
                          })
                        }
                      ]
                    }
                  ]"
                >
                  <a-select-option
                    v-for="(item, index) in gradeOptions"
                    :key="index"
                    :value="item.value"
                  >
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item
                :label="$t('class.classType')"
                :labelCol="formItemLayout.labelCol"
                :wrapperCol="formItemLayout.wrapperCol"
              >
                <a-select
                  :placeholder="$t('class.classType')"
                  style="width: 200px"
                  v-decorator="[
                    'type',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('public.pleaseChoose', {
                            content: $t('class.classType')
                          })
                        }
                      ]
                    }
                  ]"
                >
                  <a-select-option
                    v-for="(item, index) in classTypeData"
                    :key="index"
                    :value="item.id"
                  >
                    {{ $t(`${item.name}`) }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item
                :label="$t('public.startedYear')"
                :labelCol="formItemLayout.labelCol"
                :wrapperCol="formItemLayout.wrapperCol"
              >
                <a-select
                  :placeholder="$t('public.startedYear')"
                  style="width: 200px"
                  v-decorator="[
                    'year',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('public.pleaseChoose', {
                            content: $t('public.startedYear')
                          })
                        }
                      ]
                    }
                  ]"
                >
                  <a-select-option
                    v-for="(item, index) in yearOptions"
                    :key="index"
                    :value="item"
                  >
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item
                :label="$t('public.headmaster')"
                :labelCol="formItemLayout.labelCol"
                :wrapperCol="formItemLayout.wrapperCol"
              >
                <a-select
                  :placeholder="$t('public.headmaster')"
                  style="width: 200px"
                  v-decorator="[
                    'user',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('public.pleaseChoose', {
                            content: $t('public.headmaster')
                          })
                        }
                      ]
                    }
                  ]"
                >
                  <a-select-option
                    v-for="(item, index) in userOptions"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-form>
          </div>
          <div class="drawer-bottom-wrap">
            <a-button class="margin--right" @click="handleClose">
              {{ $t('handle.cancel') }}
            </a-button>
            <a-button
              type="primary"
              :loading="drawerLoading"
              @click="handleConfirm"
            >
              {{ $t('handle.confirm') }}
            </a-button>
          </div>
        </a-drawer>

        <!-- 花名册 -->

        <!-- destroyOnClose -->
        <a-drawer
          :title="$t('public.roster')"
          :visible="rosterDrawerVisible"
          height="100%"
          destroyOnClose
          wrapClassName="drawer-page-wrap"
          @close="rosterHandleClose"
          placement="bottom"
        >
          <the-class-roster
            :item-id="itemId"
            class="drawer-content"
          ></the-class-roster>
        </a-drawer>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
import { mapGetters } from 'vuex'
import TheClassRoster from './TheClassRoster.vue'

export default {
  components: {
    TheClassRoster
  },

  data() {
    return {
      campusId: localStorage.getItem('campusId'),
      status: 1,
      grade: undefined,
      year: undefined,
      classAdviserId: undefined,
      searchModel: '', //搜索内容

      tableLoading: false,
      dataSource: [],
      selectedRowKeys: [],
      total: 0,
      current: 1,
      pageSize: 50,

      drawerVisible: false,
      drawerLoading: false,
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: {
          span: 6
        },
        wrapperCol: {
          span: 17
        }
      },
      itemId: '',
      ListClassAdviser: [],
      rosterDrawerVisible: false,
      classType: 1
    }
  },

  props: {
    updateComponent: {
      type: String,
      default: ''
    },
    gradeOptions: {
      type: Array,
      default: () => []
    },
    yearOptions: {
      type: Array,
      default: () => []
    },
    userOptions: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapGetters([
      'handleRightsList',
      'userId',
      'classStatusList',
      'classTypeData'
    ])
  },

  watch: {
    updateComponent() {
      this.searchModel = ''
      this.current = 1
      this.getDataSource()
    }
  },

  created() {
    this.getDataSource()
    let data = {
      campusId: localStorage.getItem('campusId')
    }
    this.getListClassAdviser(data)
  },

  methods: {
    // moment,
    handleClick(item) {
      this.classType = item.key
      this.getDataSource()
    },
    // 搜索选项
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },

    // 展示数据
    getDataSource() {
      this.tableLoading = true
      this.$http(this.$api.GETCLASSLISTBYPAGER, {
        campusId: this.campusId,
        pageNo: this.current,
        pageSize: this.pageSize,
        name: this.searchModel,
        classStatus: this.status,
        openDate: this.year,
        grade: this.grade,
        userId: this.userId,
        classAdviserId: this.classAdviserId,
        type: this.classType
      }).then(r => {
        this.dataSource = r.data.rows
        this.total = r.data.total || 0
        this.tableLoading = false
      })
    },

    // 搜索
    handleSearch(val) {
      this.current = 1
      this.getDataSource()
    },

    // 分页
    currentChange(val) {
      this.current = val
      this.getDataSource()
    },

    showSizeChange(current, size) {
      this.current = 1
      this.pageSize = size
      this.getDataSource()
    },

    editItem(record) {
      this.itemId = record.id
      this.drawerVisible = true
      this.$nextTick().then(() => {
        this.form.setFieldsValue({
          name: record.name.split('-').pop(),
          number: record.number,
          grade: record.grade,
          user: record.userId,
          year: record.openDate,
          type: record.type
        })
      })
    },

    handleClose() {
      this.drawerVisible = false
      this.drawerLoading = false
      this.$nextTick().then(() => {
        this.form.resetFields()
      })
    },

    // 提交
    handleConfirm() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.handleEdit(values)
        }
      })
    },

    // 编辑
    handleEdit(values) {
      this.drawerLoading = true
      this.$http(this.$api.UPDATECLASS, {
        id: this.itemId,
        name: values.name,
        number: values.number,
        userId: values.user,
        grade: values.grade,
        openDate: values.year
      })
        .then(() => {
          this.$message.success(this.$t('public.saveSuccess'))
          this.handleSearch()
          this.handleClose()
        })
        .catch(() => {
          this.drawerLoading = false
        })
    },

    // 花名册
    rosterItem(record) {
      this.itemId = record.id
      this.rosterDrawerVisible = true
    },

    rosterHandleClose() {
      this.getDataSource()
      this.rosterDrawerVisible = false
    },

    // 删除
    handleDelete() {
      this.$http(this.$api.DELETECLASS, {
        id: this.itemId
      }).then(() => {
        this.$message.success(this.$t('public.deleteSuccess'))
        this.handleSearch()
      })
    },

    // 多选
    selectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    //查询全部班主任
    getListClassAdviser(data) {
      this.$http(this.$api.GETLISTCLASSADVISER, data, 'post').then(r => {
        this.ListClassAdviser = r.data
      })
    },
    errorTips() {
      this.$notification.open({
        type: 'error',
        message: this.$t('class.errorTitle'),
        description: this.$t('class.messageDesc')
      })
    },
    sucessTips(type) {
      this.$message.success(type + this.$t('class.success'))
    },
    //归档
    btnArchived() {
      if (this.selectedRowKeys.length == 0) {
        this.errorTips()
        return false
      }
      this.$http(this.$api.ARCHIVECLASS, {
        id: JSON.stringify(this.selectedRowKeys)
      }).then(() => {
        this.sucessTips(this.$t('class.archive'))
        this.handleSearch()
      })
      this.selectedRowKeys = []
    },
    //晋升
    btnPromote() {
      if (this.selectedRowKeys.length == 0) {
        this.errorTips()
        return false
      }
      this.$http(this.$api.UPGRADE, {
        id: JSON.stringify(this.selectedRowKeys)
      }).then(() => {
        this.sucessTips(this.$t('class.promotion'))
        this.handleSearch()
      })
      this.selectedRowKeys = []
    }
  }
}
</script>
<style scoped lang="less">
// .search-wrap{}
.classListBox {
  width: 100%;
  display: flex;
  .serItem:first-child {
    width: 160px;
    border-right: 1px solid #e2e6ea;
    .titleNav {
      height: 40px;
      line-height: 40px;
      padding-left: 20px;
      font-size: 15px;
    }
  }
  .serItem:last-child {
    width: calc(100% - 160px);
  }
}
.search-wrap {
  width: 100%;
  /deep/ .operate {
    height: 32px;
    width: calc(100% - 1100px);
    // padding-top: 8px;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
    align-items: center;
    padding-left: 5px;
    .ser {
      // float: right;
      // height: 40px;
      // margin-right: 10px;
    }
  }
}
.ant-btn-danger {
  background-color: #f5222d;
  color: white;
}
.ant-btn-danger:hover {
  background-color: #ec5b56;
}
@media (min-width: 500px) and (max-width: 1200px) {
  .marginCss {
    margin-left: 0px;
  }
}
@media (min-width: 1500px) and (max-width: 2000px) {
  .marginCss {
    margin-left: 20px;
  }
}
</style>
